import script from "./VideoPlayer.vue?vue&type=script&setup=true&lang=ts"
export * from "./VideoPlayer.vue?vue&type=script&setup=true&lang=ts"

import "./VideoPlayer.vue?vue&type=style&index=0&id=61d96b60&lang=scss"

const __exports__ = script;

export default __exports__